import React, { useRef, useState } from 'react';
import { forgotPassword } from 'data';
import { useNavigate } from 'react-router-dom';
import { Button, InputField, LanguageSwitcher } from 'components';
import { BlueLogo } from 'icons';
import { useTranslation } from 'react-i18next';
import { Toast } from 'primereact/toast';

export const ForgotPassword: React.FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const toast = useRef<Toast>(null);
	const [email, setEmail] = useState('');

	const handleSubmit = async () => {
		try {
			await forgotPassword(email);
		} catch (error: any) {
			// A rejected lookup must look exactly like a successful one, otherwise
			// the toast reveals which addresses have an account.
			const status = error?.response?.status;
			const isLookupRejection =
				status === 400 || status === 404 || status === 422;

			if (!isLookupRejection) {
				setEmail('');
				toast.current?.show({
					severity: 'error',
					summary: 'Error',
					detail: t('forgotPassword.errorToast'),
					life: 4000,
				});
				return;
			}
		}

		toast.current?.show({
			severity: 'success',
			summary: 'Success',
			detail: t('forgotPassword.successToast'),
			life: 4000,
		});
		setEmail('');
		navigate('/reset-password');
	};
	

	return (
		<div
			className="relative flex items-center justify-center min-h-svh bg-[#F5F7F9] flex-col space-y-[24px] px-[16px] py-[32px] sm:py-[64px]"
			tabIndex={0}>
			<Toast ref={toast} position="top-right" />
			<LanguageSwitcher className="absolute top-[16px] right-[16px] sm:top-[24px] sm:right-[24px]" />
			<div>
				<BlueLogo width={122} height={33} />
			</div>
			<div className="bg-white border-[#D5D9DF] border p-[24px] sm:p-[32px] rounded-[24px] pb-[36px] w-full text-black flex flex-col items-center max-w-[440px] sm:max-w-[500px] space-y-[17px]">
				<div className="flex flex-col space-y-[4px]">
					<h2 className="text-[24px] leading-[29px] font-[500] text-center text-[#2E435F]">
						{t('forgotPassword.title')}
					</h2>
					<h2 className="text-[14px] font-[400] text-center text-[#58697F]">
						{t('forgotPassword.subtitle')}
					</h2>
				</div>
				<div className="space-y-[12px] w-full">
				<InputField
					label={t('forgotPassword.email')}
					type="text"
					placeholder={t('forgotPassword.email')}
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				</div>
				<Button
					label={t('login.continue')}
					onClick={handleSubmit}
					style={{ width: '100%' }}
				/>
			</div>
			<p className="mt-4 text-sm text-[#58697F] font-[700]">
				<span
				className="text-[#FF6F61] cursor-pointer hover:underline"
				onClick={() => navigate('/login')}>
					{t('forgotPassword.goBack')}
				</span>
			</p>
		</div>
	);
};
